import { SubmissionService } from '../../modules/shared/services/submission.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import {
    shipmentRefreshRequest,
    shipmentRefreshSucceeded, shipmentVoidCurrent,
    shipmentVoidMultiFailure,
    shipmentVoidMultiRequest,
    shipmentVoidMultiSuccess
} from './shipment.actions';
import { filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { ActionStatusEnum } from '../../enum/action-status.enum';
import { ShipmentService } from '../../data/shipment.service';
import { MergeStrategy } from '@ngrx/data';
import { ShipmentStatusEnum } from '../../enum/shipment-status.enum';
import { shipmentTableUpdateStatuses } from '../shipments-table/shipments-table.actions';
import { selectShipmentEditorId } from '../shipment-editor/shipment-editor.state';
import { Store } from '@ngrx/store';
import { AppState } from '../index';
import { selectJournalBusyShipments } from '../journal/journal.state';

@Injectable()
export class ShipmentEffects {
    constructor(private actions$: Actions, private submissionService: SubmissionService, private shipmentService: ShipmentService,
                private store: Store<AppState>) {
    }

    shipmentRefreshRequest$ = createEffect(() => this.actions$.pipe(
        ofType(shipmentRefreshRequest),
        switchMap(action => this.shipmentService.getByKey(({ key: action.shipmentId }))),
        map(shipment => shipmentRefreshSucceeded({ shipment }))
    ));

    shipmentRefreshSucceeded$ = createEffect(() => this.actions$.pipe(
        ofType(shipmentRefreshSucceeded),
        tap(action => this.shipmentService.updateOneInCache(action.shipment, { mergeStrategy: MergeStrategy.OverwriteChanges }))
    ), { dispatch: false });

    shipmentVoidMultiRequest$ = createEffect(() => this.actions$.pipe(
        ofType(shipmentVoidMultiRequest),
        switchMap(action => this.submissionService.voidMulti(action.shipmentIds)),
        map(result => result.result === ActionStatusEnum.COMPLETED ?
            shipmentVoidMultiSuccess({ shipmentIds: result.shipmentIds }) :
            shipmentVoidMultiFailure({ shipmentIds: result.shipmentIds, messages: result.messages }))
    ));

    shipmentVoidMultiSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(shipmentVoidMultiSuccess),
        tap(action => this.shipmentService.updateManyInCache(action.shipmentIds.map(id => ({ id, statusCode: ShipmentStatusEnum.VOID })))),
        map(action => shipmentTableUpdateStatuses({ shipmentIds: action.shipmentIds, newState: ShipmentStatusEnum.VOID }))
    ));

    shipmentVoidCurrent = createEffect(() => this.actions$.pipe(
        ofType(shipmentVoidCurrent),
        withLatestFrom(this.store.select(selectShipmentEditorId), this.store.select(selectJournalBusyShipments)),
        filter(([ action, id, busy ]) => busy.indexOf(id) === -1),
        map(([ action, id ]) => shipmentVoidMultiRequest({ shipmentIds: [ id ]}))
    ));


}
